module.exports = __webpack_public_path__ + "img/title-.9e42eee0.png";